import { render } from "./FraudexCheckPopup.vue?vue&type=template&id=547e97a5&scoped=true&ts=true"
import script from "./FraudexCheckPopup.vue?vue&type=script&lang=ts"
export * from "./FraudexCheckPopup.vue?vue&type=script&lang=ts"

import "./FraudexCheckPopup.vue?vue&type=style&index=0&id=547e97a5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547e97a5"]])

export default __exports__